import { computed, useRoute, useStore } from '@nuxtjs/composition-api'
import useLocale from './useLocale'

const { getTitle } = require(`../${process.env.TEMPLATE_ID}/middleware/title`)

export default function useTitle() {
  const store = useStore()
  const route = useRoute()

  const { locale } = useLocale()
  const title = computed(() => store.state.headerModule.title)

  return {
    title,
    getTitle: (path = route.value.path) => {
      return getTitle(path, locale.value)
    }
  }
}
